module.exports = __webpack_public_path__ + "static/media/departuresIcon.aa878e75.svg";